/**
 * Classe responsável por armazenar as informações dos filtros necessesários para as pesquisas
 */
export class HttpFilter {
    constructor(filters) {
        this.filters = filters;
    }
    buildFilters() {
        let strFilter = "?";
        this.filters.forEach(filter => {
            strFilter += filter.buildPartFilter() + "&";
        });
        return strFilter.substring(0, strFilter.length - 1);
    }
    addFilter(filter) {
        this.filters.push(filter);
    }
}
